import { MODULE_LINK_TYPE } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/ilt/${seriesId}/${moduleId}/sessions`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/ilt/${seriesId}/${moduleId}/sessions/manage/upcoming`,
  [MODULE_LINK_TYPE.ANALYTICS]: () => null,
};

export const LEARNER = {};
